import React, { useEffect, useState } from 'react'
import DashBoard from '../../components/DashBoard/DashBoard'
import DashBoardStats from '../../components/DashBoard/DashBoardStats'
const Index = ({ setHeading ,userId}) => {
  const [renderComponent, SetrendeComponent] = useState('users')
  useEffect(() => {
    setHeading('Dashboard')
  }, [])
  return (
    <div>
      <DashBoardStats setRenderComponent={SetrendeComponent} renderComponent={renderComponent} userId={userId}/>
      <DashBoard renderComponent={renderComponent} />
    </div>
  )
}

export default Index
